export function ncDeclarationPaths(input, article, internalCaseId = "") {
  if (internalCaseId) {
    const detail = `/qualita/nc-interne/documenti/${encodeURIComponent(
      internalCaseId
    )}/`;
    return {
      detail,
      save: detail,
      origin: `${detail}origine/`,
      pdf: `${detail}8d/`,
    };
  }
  const detail = `/arts/nc/${encodeURIComponent(
    input.numero
  )}/${encodeURIComponent(input.riga)}/`;
  return {
    detail,
    save: `/arts/nc/${encodeURIComponent(article)}/`,
    origin: "/arts/nc/",
    pdf: `${detail}8d/`,
  };
}
